<div class="{{ themeClassName }}">
  <router-outlet></router-outlet>
</div>